import { buyBonusType } from "./type";

const initialAuthState = {
  buyBonusList: null,
  isLoading: false,
  statusCode: null
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case buyBonusType.GET_BUY_BONUS_LIST_REQUEST:
      return { ...state, isLoading: true };
    case buyBonusType.GET_BUY_BONUS_LIST_SUCCESS:
      return { ...state, isLoading: false, buyBonusList: action.payload.data };
    case buyBonusType.GET_BUY_BONUS_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};
